import React, { useEffect } from "react";
import useScreenerHistory from "../../../utils/CustomHooks/useScreenerHistory";
import moment from "moment";
import ScreenerHistoryData from "./ScreenerHistoryData";
export default function ScreenerHistory({ screenerHistory }) {
  return (
    <div className="col-md-12">
      <div className="table-responsive ">
        <table className="table domain-table table-bordered">
          <thead>
            <tr className=" ">
              <td className="">Action</td>
              <td className="">Time </td>
              <td className="">By</td>
            </tr>
          </thead>
          <tbody>
            {screenerHistory && screenerHistory.length > 0 ? (
              screenerHistory.map((x, i) => (
                <ScreenerHistoryData x={x} key={i} i={i} />
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  <span className="font-weight-bold">Oops! No Data Found</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
